import axios from 'axios';
import OSS from 'ali-oss';

const STS_URL = '/shared-base-data/basic/v1/oss/key';
let cached = { client: null, expireAt: 0 };
export async function getOssClient() {
  const now = Date.now();
  // 提前 60s 刷新，避免使用即将过期的凭证
  if (cached.client && now < cached.expireAt - 60000) {
    return cached.client;
  }

  const { data: creds } = await axios.get(STS_URL);

  if (!creds || !creds.accessKeyId || !creds.accessKeySecret || !creds.securityToken) {
    throw new Error('获取 OSS 临时凭证失败，请检查后端 STS 接口');
  }

  const client = new OSS({
    region: 'oss-cn-beijing', // 阿里云获取
    accessKeyId: creds.accessKeyId,
    accessKeySecret: creds.accessKeySecret,
    stsToken: creds.securityToken,
    bucket: 'v2cs-oss', // 要存储的目录名
    secure: true, // 生产环境使用 HTTPS
  });

  const expireAt = creds.expireTime
    ? new Date(creds.expireTime).getTime()
    : now + 30 * 60 * 1000; // 默认 30 分钟
  cached = { client, expireAt };
  return client;
}
